import { render, staticRenderFns } from "./AllNotifications.vue?vue&type=template&id=5de5c02b"
import script from "./AllNotifications.vue?vue&type=script&lang=ts"
export * from "./AllNotifications.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5de5c02b')) {
      api.createRecord('5de5c02b', component.options)
    } else {
      api.reload('5de5c02b', component.options)
    }
    module.hot.accept("./AllNotifications.vue?vue&type=template&id=5de5c02b", function () {
      api.rerender('5de5c02b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/notification/AllNotifications.vue"
export default component.exports